<main>
  <FirebaseApp {firebase}>
    <User persist={sessionStorage}>
      <div slot="loading">Loading...</div>

      <div slot="signed-out">
        <Login />
      </div>

      {#if $appState.auth_user}
        <div>
          {#if loadedUser}
            <slot />
          {:else}
            <!-- Loading user profile... -->
          {/if}
        </div>
      {/if}
    </User>
  </FirebaseApp>
</main>

<script lang="ts">
  import { appState } from "../../lib/appState.js";
  import { goto, isActive } from "@sveltech/routify";
  import { logging } from '../../lib/logging.js';
  import Login from "./Login.svelte";

  import { FirebaseApp, User } from "sveltefire";

  let sessionStorage = window.localStorage;
  let firebase = window.firebase;

  if (!$appState.auth_user) {
    $appState.user = undefined;
  }

  let loadedUser = $appState.user !== undefined;

  firebase.auth().onAuthStateChanged((user) => {

    $appState.auth_user = user;

    loadedUser = false;

    if (user) {

      logging.setUser(user.email || undefined);

      firebase
        .firestore()
        .collection("users_v1")
        .doc($appState.auth_user.email)
        .get()
        .then((user) => {
          if (user.data()) {
            $appState.user = user.data() as User_v1;
          }
          else {
            $appState.user = undefined;
          }

          loadedUser = true;

          redirect();
        });
    } else {
      $appState.user = undefined;
    }
  });


  function redirect() {

    if($appState.user) {
      // user record exists

      if ($appState.user.company) {
        if(!isUserValid($appState.user)){
          $goto("start/business/personal");
        }
        else if ($appState.user.isAdmin && $isActive('/admin')) {
          // no redirect
        }
        else if (!$isActive('/business')) {
          $goto("/business");
        }
      } else if ($appState.user.charity) {
        if(!isUserValid($appState.user)){
          $goto("start/charity/personal");
        }
        else if ($appState.user.isAdmin && $isActive('/admin')) {
          // no redirect
        }
        else if (!$isActive('/charity')) {
          $goto("/charity");
        }
      } else if ($appState.user.isAdmin) {
        if(!$isActive('/admin')) {
          $goto("/admin");
        }
      } else {
        // user record exists, but not associated with organisation account
        $goto("/start");
      }
    } else {
      // user authentication account exists, but no user record
      $goto("/start");
    }
  }

  function isUserValid(user : User_v1 | undefined) {
    return user && user.firstName && user.lastName;
  }






</script>
